import { InvoiceTranslation } from 'locales/de/pages/Billing/invoice';

const en: InvoiceTranslation = {
  title: 'Invoices',
  invoiceTitle: 'Invoice',
  cancelledInvoiceTitle: 'Cancelled Invoice',
  invoiceNumber: 'Invoice Number',
  bookingCode: 'Booking Code',
  creator: 'Creator',
  customers: {
    title: 'Customers'
  },
  downloadBulkImportTemplate: 'Bulkimport template',
  createInvoice: 'Create Invoice',
  approveInvoice: 'Approve Invoice',
  approveManual: 'Approve Invoice manually',
  denyInvoice: 'Deny Invoice',
  deleteInvoice: 'Delete Invoice',
  cancelInvoice: 'Cancel Invoice',
  toCancelledInvoice: 'To Cancelled Invoice',
  toOriginalInvoice: 'To Original Invoice',
  openInDMS: 'Open in DMS',
  editInvoice: 'Edit Invoice',
  newArticle: 'New Invoice Article',
  articleName: 'Article Name',
  importInvoices: 'import invoices',
  importInvoicesLoading: 'The invoices are being uploaded...',
  importInvoicesLoading2: 'Please be patient for a moment.',
  states: {
    draft: 'Draft',
    open: 'Ready',
    incomplete: 'Incomplete',
    approved: 'Approved',
    denied: 'Denied',
    archived: 'Archived',
    cancelled: 'Cancelled',
    final: 'Transmitted'
  },
  validation: {
    reminderKey: 'The reminder key must be either 13 or 14 for STOK',
    costBearer: 'One of the two fields must be filled in: Cost bearer, Cost centre',
    missingFields: 'The invoice is incomplete. Fields still need to be filled in.',
    onlyNumbersLeadingZero:
      'The field must be a 5-digit number starting with a leading zero (e.g. 01234).',
    reverseCharge: 'For foreign customers with a valid VAT ID, the VAT may only be 0%.',
    taxesAllSame: 'All tax rates in the invoice items must be identical.',
    ustidKey: 'The customer must have a valid VAT ID for the selected tax rate.',
    ustidKey45:
      'For VAT code 45, the country must not be Germany and no VAT number must be provided.'
  },
  formikErrors: {
    labelMarkREADY: 'These fields must be filled in so that the invoice can be marked as "Ready".',
    labelMarkAPPROVE: 'These fields must be filled in so that the invoice can be approved',
    keys: {
      customerVersionId: 'Customer',
      expertContactVersionId: 'Expert Contact',
      bankAccount: 'Bank Account',
      paymentTarget: 'Payment Target',
      reminderKey: 'Reminder key',
      invoiceDate: 'Invoice Date',
      revenueTypeVersionId: 'Revenue Type',
      invoiceArticles: 'Invoice Articles',
      costBearer: 'Cost bearer',
      costCentre: 'Cost centre',
      chapter: 'Chapter',
      title: 'Title',
      departmentVersionId: 'Department',
      additionalRecipients: 'Additional e-mail recipients',
      insArt: 'Ins/A-Art',
      customer: {
        firstName: 'Customer first name',
        lastName: 'Customer last name',
        email: 'Customer email',
        zip: 'Customer- zip',
        city: 'Customer city',
        address: 'Customer street',
        country: 'Customer country',
        ustId: 'Customer VAT Number',
        phone: 'Customer phone',
        companyName: 'Customer company name',
        customerId: 'Customer ZP-ID'
      }
    }
  },
  tabs: {
    all: 'All',
    open: 'Open',
    closed: 'Closed',
    drafts: 'Drafts',
    archived: 'Archived'
  },
  filter: {
    deniedInvoiceFilter: 'Display denied invoices'
  },
  dialogs: {
    denyInvoiceTitle: 'Deny Invoice',
    denyInvoiceMessage: 'Please provide a reason for denying the invoice:'
  },
  alerts: {
    loadingError: 'The invoice could not be loaded.',
    pdfLoadingError: 'The pdf-preview could not be loaded.',
    successfulInvoiceCreate: 'The invoice has been created.',
    successfulInvoiceUpdate: 'The invoice has been updated.',
    failedInvoiceCreate: 'The invoice could not be created.',
    failedInvoiceUpdate: 'The invoice could not be updated.',
    invoiceDeniedText: 'The invoice has been denied: {{reason}}',
    invoiceDeniedWithoutReason: 'The invoice has been denied'
  },
  invoiceCreate: {
    title: 'Create Invoice',
    invoiceDate: 'Invoice Date',
    customerId: 'ZP-ID',
    customerIdTooltip:
      'The payment partner ID can only be set via the customer import. When a new customer is created, it is automatically set to 0.',
    bankAccount: {
      stok: 'Staatsoberkasse',
      sparkasse: 'Sparkasse'
    },
    customerWrite: 'Should the customer data be written to the customer?',
    saveCustomerInfo: 'Warning, this will overwrite the customer data.'
  },
  invoiceStateChip: {
    incompleteTooltip: 'The invoice is incomplete. Please check it in the detailed view.'
  },
  detail: {
    details: 'Details',
    paymentTarget: '{{target}} Days',
    paymentTargetNow: 'now',
    reminderKey: 'Reminder key',
    costFields: 'Cost fields',
    chapter: 'Chapter',
    title: 'Title',
    costBearer: 'Cost bearer',
    costCentre: 'Cost Centre',
    insArt: 'Ins/A-Art',
    expertContact: 'Expert contact (TH internal)',
    department: 'Department / Faculty (TH internal)',
    additionalRecipients: 'Additional email-recipients',

    articles: {
      existing: 'Existing articles',
      confirmDelete: 'Do you really want to delete the invoice position?',
      noArticles: 'No invoice item yet'
    },
    servicePeriod: 'Service Period',
    yourReference: 'Your Reference (Customer Reference)',
    revenueType: 'Revenue Type',
    markAsReady: 'Please click for approval',
    markedAsReady: 'Submitted to finance department',
    pdfPreview: 'Invoice preview',
    editModeTitle: 'Edit Mode',
    editModeMessage: 'In edit mode, all changes will be immediately applied.',
    readyForApprovalMessage:
      'The invoice is ready for approval. Please mark the invoice as approved.',
    readyForApprovalTitle: 'Invoice Draft: Ready for approval'
  },
  noInvoiceNumberInDraftState: 'Draft',
  noBookingCodeInDraftState: 'Draft',
  noOptions: 'No options found.',
  typeToSearch: 'Type to search...',
  tooltips: {
    defaultTaxChanged: 'The default tax has been changed.',
    moreThanOneTax:
      'The invoice has positions with different tax rates. The invoice is therefore split into several invoices when approved.',
    isFreeTextArticle: 'This is a self-created article.',
    hasFreeTextArticle: 'The invoice has positions with self-created articles.',
    foreignTaxNotNull: 'Tax rate does not comply with the regulation for foreign payment partners.',
    costCentre: 'For invoices with cost centre, please contact the finance department',
    departmentsCanOnlyBeChangedByAdmin:
      'The contents of the departments/faculties can only be maintained by billing-administrators',
    additionalRecipients:
      'The recipients specified here will be set to CC when the invoice is sent. They are not shown separately on the invoice. Confirm the entry by pressing the Enter key.'
  },
  importErrors: {
    gotItButton: 'Got it',
    title: 'Notes in invoices',
    subTitleErrors: 'Errors in invoices',
    subTitleWarnings: 'Warnings in invoices',
    notCreatedInvoices: 'It was not possible to create {{number}} invoices.',
    invoiceErrorTitle: 'The invoice in line {{position}} contains the following problems:',
    invoiceDataTitle: 'Error in invoice data',
    invoiceDataWarningTitle: 'Warnings in invoice data:',
    invoiceDate:
      'The invoice date must have one of the following formats: YYYY-MM-DD or DD.MM.YYYY.',
    servicePeriodStart:
      'The service period start must have one of the following formats: YYYY-MM-DD or DD.MM.YYYY.',
    servicePeriodEnd:
      'The service period end must have one of the following formats: YYYY-MM-DD or DD.MM.YYYY.',
    paymentTarget: 'The payment target must have one of the following values 14d, 30d, 60d, 90d.',
    salesTaxKey: 'The salestax key must have one of the following values 00, 41, 21, 81, 86.',
    bankAccount: 'The bank account must have one of the following values STOK, Sparkasse.',
    revenueTypeMore: 'More than one revenue account was found with the number,',
    revenueType: 'The revenue account is not stored in the system,',
    creator: 'The specified UID for the creator does not exist in the system,',
    expert: 'The specified UID of the expert contact does not exist in the system,',
    costBearer: 'Cost bearer was not specified.',
    costBearerOnlyNumber: 'Cost Bearer can only contain numbers.',
    costCentre: 'Cost Centre can only contain numbers.',
    costBeaererOrCostCentre: 'One of the two fields must be filled in: Cost bearer, Cost centre.',
    customerTitle: 'Error in customer data:',
    customerTitleWarnings: 'Warnings in customer data:',
    customerFirstName: 'The customers first name was not specified',
    customerLastName: 'The customers surname was not entered.',
    customerPhone: 'The telephone number provided is invalid.',
    customerEmail: 'The email provided is invalid',
    customerCompanyName: 'The customers company name was not specified',
    customerCity: 'The city in the customers address was not specified.',
    customerAddress: 'The street in the customers address was not specified.',
    customerCountry: 'The customers country must comply with the ISO 3166Alpha2 format',
    customerVatNumber: 'The customers VAT number is not valid',
    articleTitle: 'Errors in article {{position}}: ',
    articleTitleWarning: 'Warnings in article {{position}}: ',
    firstArticle: 'The first article must always be filled in',
    articleName: 'The name of the article was not specified.',
    articleDescription: 'The description of the article was not specified.',
    articleAmount: 'The article amount of the article was not specified.',
    articleUnit:
      'The unit of the item must have the following values: LE, St, Std, Min, kg, km, m, m2',
    articlePrice: 'The article price of the article was not specified.',
    oneArticleMustBeSet: 'The upload must contain at least one complete article',
    yourReferenceTooLong: 'The reference field must not exceed 12 characters.',
    reverseChargeHint:
      'For foreign customers with a valid VAT ID, the VAT may only be 0%. Please select one of the following VAT codes for the invoice: 00, 41 or 21.',
    generalError: 'Problems have occurred for the following value: {{value}}',
    department: 'The specified department was not found in the target system.',
    departmentFormat: 'The department must be specified in the following format Name_Email.',
    chapterFormat:
      'The chapter must begin with a 0 and contain exactly four further digits (e.g. 01234).',
    additionalRecipients:
      'Additional email recipients require a valid email format and are separated by commas.',
    salesTaxKey45:
      'For VAT code 45, the country must not be Germany and no VAT number must be provided.',
    warnings: {
      ZPIDNotFound:
        'The payment partner ID was not found in the system. An attempt is made to assign the customer via the address. If it cannot be assigned, it is created with payment partner ID 0',
      firstNameNotSame: 'The customer stored in the system has a different first name.',
      lastNameNotSame: 'The customer stored in the system has a different last name.',
      emailNotSame: 'The customer stored in the system has a different email address.',
      phoneNotSame: 'The customer stored in the system has a different phone number.',
      companyNameNotSame: 'The customer stored in the system has a different company name.',
      cityNotSame: 'The customer stored in the system has a different city.',
      countryNotSame: 'The customer stored in the system has a different country.',
      addressNotSame: 'The customer stored in the system has a different address.',
      zipNotSame: 'The customer stored in the system has a different zip code.',
      articleAmountLessThan1: 'For an item, a quantity of 0 was specified.',
      ustIdNotSame: 'The customer stored in the system has a different UstId.',
      foreignCompanyTaxNotNull:
        'For foreign customers with a valid VAT ID, the VAT should be 0%. It is therefore best to use the following VAT codes in your invoice: 00, 41 or 21. In exceptional cases, the VAT code 81 is also useful.'
    }
  }
};

export default en;
